var map = {
	"./Error": [
		22567,
		7,
		7407,
		8898,
		2567
	],
	"./Error.tsx": [
		22567,
		7,
		7407,
		8898,
		2567
	],
	"./Loading": [
		97816,
		9,
		7407,
		8898,
		7816
	],
	"./Loading.tsx": [
		97816,
		9,
		7407,
		8898,
		7816
	],
	"./declaration/Crypto": [
		72570,
		7,
		7407,
		8898,
		2570
	],
	"./declaration/Crypto.tsx": [
		72570,
		7,
		7407,
		8898,
		2570
	],
	"./declaration/Inbt": [
		24497,
		7,
		7407,
		8898,
		4497
	],
	"./declaration/Inbt.tsx": [
		24497,
		7,
		7407,
		8898,
		4497
	],
	"./declaration/Ofbt": [
		1488,
		7,
		7407,
		8898,
		1488
	],
	"./declaration/Ofbt.tsx": [
		1488,
		7,
		7407,
		8898,
		1488
	],
	"./declaration/TisgServices": [
		74738,
		7,
		7407,
		8898,
		4738
	],
	"./declaration/TisgServices.tsx": [
		74738,
		7,
		7407,
		8898,
		4738
	],
	"./deposit/AlreadyConfirmed": [
		46845,
		7,
		7407,
		8898,
		6845
	],
	"./deposit/AlreadyConfirmed.tsx": [
		46845,
		7,
		7407,
		8898,
		6845
	],
	"./deposit/Cancelled": [
		34941,
		7,
		7407,
		8898,
		4941
	],
	"./deposit/Cancelled.tsx": [
		34941,
		7,
		7407,
		8898,
		4941
	],
	"./deposit/CardNoApplicablePsp": [
		8426,
		7,
		7407,
		8898,
		8426
	],
	"./deposit/CardNoApplicablePsp.tsx": [
		8426,
		7,
		7407,
		8898,
		8426
	],
	"./deposit/ConfirmationExpired": [
		89406,
		7,
		7407,
		8898,
		9406
	],
	"./deposit/ConfirmationExpired.tsx": [
		89406,
		7,
		7407,
		8898,
		9406
	],
	"./deposit/Expired": [
		83499,
		7,
		7407,
		8898,
		3499
	],
	"./deposit/Expired.tsx": [
		83499,
		7,
		7407,
		8898,
		3499
	],
	"./deposit/ExpiredV2": [
		82944,
		7,
		7407,
		8898,
		2944
	],
	"./deposit/ExpiredV2.tsx": [
		82944,
		7,
		7407,
		8898,
		2944
	],
	"./deposit/Failed": [
		18954,
		7,
		7407,
		8898,
		8954
	],
	"./deposit/Failed.tsx": [
		18954,
		7,
		7407,
		8898,
		8954
	],
	"./deposit/HostIframe": [
		96715,
		9,
		6715
	],
	"./deposit/HostIframe.tsx": [
		96715,
		9,
		6715
	],
	"./deposit/Index": [
		83918,
		7,
		7407,
		8898,
		3918
	],
	"./deposit/Index.tsx": [
		83918,
		7,
		7407,
		8898,
		3918
	],
	"./deposit/Interrupted": [
		45535,
		7,
		7407,
		8898,
		5535
	],
	"./deposit/Interrupted.tsx": [
		45535,
		7,
		7407,
		8898,
		5535
	],
	"./deposit/ModalClosed": [
		66152,
		7,
		7407,
		8898,
		6152
	],
	"./deposit/ModalClosed.tsx": [
		66152,
		7,
		7407,
		8898,
		6152
	],
	"./deposit/NoApplicablePsp": [
		77159,
		7,
		7407,
		8898,
		7159
	],
	"./deposit/NoApplicablePsp.tsx": [
		77159,
		7,
		7407,
		8898,
		7159
	],
	"./deposit/Pending": [
		61945,
		7,
		7407,
		8898,
		1945
	],
	"./deposit/Pending.tsx": [
		61945,
		7,
		7407,
		8898,
		1945
	],
	"./deposit/Processing": [
		92883,
		7,
		7407,
		8898,
		2883
	],
	"./deposit/Processing.tsx": [
		92883,
		7,
		7407,
		8898,
		2883
	],
	"./deposit/Success": [
		43090,
		7,
		7407,
		8898,
		3090
	],
	"./deposit/Success.tsx": [
		43090,
		7,
		7407,
		8898,
		3090
	],
	"./identity-verification/CardCancelled": [
		55472,
		7,
		7407,
		8898,
		5472
	],
	"./identity-verification/CardCancelled.tsx": [
		55472,
		7,
		7407,
		8898,
		5472
	],
	"./identity-verification/CardFailed": [
		48792,
		7,
		7407,
		8898,
		8792
	],
	"./identity-verification/CardFailed.tsx": [
		48792,
		7,
		7407,
		8898,
		8792
	],
	"./identity-verification/CardSuccess": [
		28022,
		7,
		7407,
		8898,
		8022
	],
	"./identity-verification/CardSuccess.tsx": [
		28022,
		7,
		7407,
		8898,
		8022
	],
	"./top-redirect/Index": [
		91757,
		9,
		1757
	],
	"./top-redirect/Index.tsx": [
		91757,
		9,
		1757
	],
	"./transfer/Pending": [
		24199,
		7,
		7407,
		8898,
		4199
	],
	"./transfer/Pending.tsx": [
		24199,
		7,
		7407,
		8898,
		4199
	],
	"./widget/Withdrawability": [
		79364,
		7,
		7407,
		8898,
		9364
	],
	"./widget/Withdrawability.tsx": [
		79364,
		7,
		7407,
		8898,
		9364
	],
	"./widget/declaration/DepositDetails": [
		1111,
		7,
		7407,
		8898,
		1111
	],
	"./widget/declaration/DepositDetails.tsx": [
		1111,
		7,
		7407,
		8898,
		1111
	],
	"./widget/declaration/PopUpload": [
		85400,
		7,
		7407,
		8898,
		5400
	],
	"./widget/declaration/PopUpload.tsx": [
		85400,
		7,
		7407,
		8898,
		5400
	],
	"./withdraw/Cancelled": [
		55270,
		7,
		7407,
		8898,
		5270
	],
	"./withdraw/Cancelled.tsx": [
		55270,
		7,
		7407,
		8898,
		5270
	],
	"./withdraw/Expired": [
		75988,
		7,
		7407,
		8898,
		5988
	],
	"./withdraw/Expired.tsx": [
		75988,
		7,
		7407,
		8898,
		5988
	],
	"./withdraw/Failed": [
		29834,
		7,
		7407,
		8898,
		9834
	],
	"./withdraw/Failed.tsx": [
		29834,
		7,
		7407,
		8898,
		9834
	],
	"./withdraw/Index": [
		19025,
		7,
		7407,
		8898,
		9025
	],
	"./withdraw/Index.tsx": [
		19025,
		7,
		7407,
		8898,
		9025
	],
	"./withdraw/Interrupted": [
		48017,
		7,
		7407,
		8898,
		8017
	],
	"./withdraw/Interrupted.tsx": [
		48017,
		7,
		7407,
		8898,
		8017
	],
	"./withdraw/LegacyConfirmRedirect": [
		50319,
		7,
		8898,
		319
	],
	"./withdraw/LegacyConfirmRedirect.tsx": [
		50319,
		7,
		8898,
		319
	],
	"./withdraw/ModalClosed": [
		58839,
		7,
		7407,
		8898,
		8839
	],
	"./withdraw/ModalClosed.tsx": [
		58839,
		7,
		7407,
		8898,
		8839
	],
	"./withdraw/NoApplicablePsp": [
		29177,
		7,
		7407,
		8898,
		9177
	],
	"./withdraw/NoApplicablePsp.tsx": [
		29177,
		7,
		7407,
		8898,
		9177
	],
	"./withdraw/Pending": [
		72979,
		7,
		7407,
		8898,
		2979
	],
	"./withdraw/Pending.tsx": [
		72979,
		7,
		7407,
		8898,
		2979
	],
	"./withdraw/PendingSuspicious": [
		80556,
		7,
		7407,
		8898,
		556
	],
	"./withdraw/PendingSuspicious.tsx": [
		80556,
		7,
		7407,
		8898,
		556
	],
	"./withdraw/Requested": [
		45367,
		7,
		475
	],
	"./withdraw/Requested.tsx": [
		45367,
		7,
		475
	],
	"./withdraw/Success": [
		21013,
		7,
		7407,
		8898,
		1013
	],
	"./withdraw/Success.tsx": [
		21013,
		7,
		7407,
		8898,
		1013
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 76385;
module.exports = webpackAsyncContext;